// extracted by mini-css-extract-plugin
module.exports = {"cta":"styles_cta__3893P","author":"styles_author__1jKw4"};